import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const labelCls = "text-xs uppercase tracking-[0.25em] text-foreground/80";

export function TextField({
  id,
  label,
  required,
  type = "text",
  maxLength = 120,
  wide,
  inputMode,
}: {
  id: string;
  label: string;
  required?: boolean;
  type?: string;
  maxLength?: number;
  wide?: boolean;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
}) {
  return (
    <div className={wide ? "md:col-span-2" : undefined}>
      <Label htmlFor={id} className={labelCls}>
        {label}
        {required ? " *" : ""}
      </Label>
      <Input
        id={id}
        name={id}
        type={type}
        required={required}
        maxLength={maxLength}
        inputMode={inputMode}
        className="mt-2 h-12 rounded-none bg-background"
      />
    </div>
  );
}

export function SelectField({
  id,
  label,
  options,
  required,
  wide,
}: {
  id: string;
  label: string;
  options: string[];
  required?: boolean;
  wide?: boolean;
}) {
  return (
    <div className={wide ? "md:col-span-2" : undefined}>
      <Label htmlFor={id} className={labelCls}>
        {label}
        {required ? " *" : ""}
      </Label>
      <select
        id={id}
        name={id}
        required={required}
        defaultValue=""
        className="mt-2 h-12 w-full rounded-none border border-input bg-background px-3 text-sm text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
      >
        <option value="" disabled>
          Select…
        </option>
        {options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    </div>
  );
}

export function AreaField({ id, label, maxLength = 1000 }: { id: string; label: string; maxLength?: number }) {
  return (
    <div className="md:col-span-2">
      <Label htmlFor={id} className={labelCls}>
        {label}
      </Label>
      <Textarea id={id} name={id} rows={5} maxLength={maxLength} className="mt-2 rounded-none bg-background" />
    </div>
  );
}

/** Read trimmed string values from a FormData object. */
export function readForm(form: HTMLFormElement) {
  const fd = new FormData(form);
  return (key: string) => String(fd.get(key) || "").trim();
}
